import React from "react";
import { useSelector } from "react-redux";
import SuggestionBox from "../../../common/suggestionBox/SuggestionBox";
import Summary from "../../../components/yourAssets/BOA/sonstiges/Summary";
import { visited } from "../../../redux/slices/features/assetsOnBoardingSlice";

const Sonstiges = ({ next, back, tabText }) => {
  const updates = useSelector((state) => state.auditTrail.updates);
  return (
    <>
      <Summary next={next} back={back} updates={updates} />{" "}
      <SuggestionBox mainText={tabText} setVisited={visited} />
    </>
  );
};

export default Sonstiges;
